<template>
  <div class="mt-20">
    <div class="flex justify-center px-4 py-8">
      <!-- <LogoEsriSpain width="400" /> -->
      <div class="w-64">
        <img src="../assets/logo_esri.png" alt="Conferencia Esri España 2020" />
      </div>
    </div>

    <div>
      <h1 class="mt-20 text-3xl font-bold"><slot name="title"/></h1>
      <div class="my-12 px-4">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
// import LogoEsriSpain from '@/components/LogoEsriSpain'

export default {
  // components: { LogoEsriSpain },
}
</script>
